import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import { cn } from '../../lib/utils'

type SwitchSize = 'sm' | 'md'
type SwitchColor = 'base'
interface SwitchProps
  extends React.ComponentProps<typeof SwitchPrimitive.Root> {
  size?: SwitchSize
  color?: SwitchColor
}

const sizeStyles: Record<SwitchSize, { root: string; thumb: string }> = {
  sm: {
    root: 'w-9 h-[1.175rem]',
    thumb:
      'size-3 ltr:data-[state=checked]:translate-x-[calc(100%+0.5rem)] rtl:data-[state=checked]:-translate-x-[calc(100%+0.5rem)]',
  },
  md: {
    root: 'w-11 h-[1.375rem]',
    thumb:
      'size-4 ltr:data-[state=checked]:translate-x-[calc(100%+0.5rem)] rtl:data-[state=checked]:-translate-x-[calc(100%+0.5rem)]',
  },
}

const colorStyles: Record<SwitchColor, { checked: string; thumb: string }> = {
  base: {
    checked: 'bg-base-main gradient-to-b from-white-30 to-white-0 ',
    thumb: 'bg-neutral-surface-light',
  },
}

function Switch({
  className,
  size = 'md',
  color = 'base',
  ...props
}: SwitchProps) {
  const sizeStyle = sizeStyles[size]
  const colorStyle = colorStyles[color]

  return (
    <SwitchPrimitive.Root
      data-slot='switch'
      className={cn(
        'bg-blend-overlay cursor-pointer data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        sizeStyle.root,
        colorStyle.checked,
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot='switch-thumb'
        className={cn(
          'bg-background dark:data-[state=unchecked]:bg-foreground pointer-events-none block rounded-full ring-0 transition-transform  data-[state=unchecked]:translate-x-0',
          sizeStyle.thumb,
          colorStyle.thumb,
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
